var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "lpu-schedule-slots",
      class: _setup.isMobile
        ? "lpu-schedule-slots--mobile"
        : "lpu-schedule-slots--desktop",
    },
    [
      _vm._l(_setup.visibleSlots, function (slot, index) {
        return _c(
          "button",
          {
            key: `${slot.time}-${slot.doctor_id}-${index}`,
            staticClass: "lpu-schedule-slots__button text-subtitle-1",
            class: { "lpu-schedule-slots__button--disabled": _vm.isDisabled },
            attrs: {
              type: "button",
              "data-qa": _vm.slotQa,
              "data-google-goal": "click_appointment_slot",
              disabled: _vm.isDisabled,
            },
            on: {
              click: function ($event) {
                return _setup.onSlotClick($event, slot)
              },
            },
          },
          [_vm._v("\n    " + _vm._s(slot.time) + "\n  ")]
        )
      }),
      _vm._v(" "),
      _setup.hasExpandButton
        ? _c(
            "button",
            {
              staticClass: "lpu-schedule-slots__expand",
              attrs: { type: "button", "data-qa": _vm.expandQa },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _setup.toggleExpanded.apply(null, arguments)
                },
              },
            },
            [
              _c("span", {
                staticClass: "ui-icon-fz-big",
                class: [
                  _setup.isExpanded ? "ui-icon-arrow-up" : "ui-icon-arrow-down",
                  _setup.ff_lpu_branding_page_v5
                    ? "text-lpu-branding-color-text"
                    : "text-lpu-branding-color-primary",
                ],
              }),
            ]
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }